import {
  MDBContainer,
  MDBBtn,
  MDBModal,
  MDBModalHeader,
  MDBModalFooter,
  MDBModalBody,
} from 'mdbreact';
import React, {
  useContext, useState, useEffect, useRef,
} from 'react';
import DatePicker from 'react-date-picker';
import { UserContext } from '../UserContext';
import DataTable from '../DataTable';

function PastEvents() {
  const baseURL = process.env.REACT_APP_API_BASEURL;
  const userContext = useContext(UserContext);

  const [eventData, setEventData] = useState(null);
  const [eventDataError, setEventDataError] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedEventId, setSelectedEventId] = useState(null); //

  const modifyEventNameRef = useRef(null);
  const modifyEventCategoryRef = useRef(null);
  const modifyEventMaxHoursRef = useRef(null);
  const modifyEventMinHoursRef = useRef(null);
  const modifyEventCommentsRef = useRef(null);
  const [modifyEventDateVal, onModifyEventDateValChange] = useState(new Date());

  const columns = [
    { name: 'Activity ID', options: { filter: false } },
    { name: 'Activity Name', options: { filter: false } },
    { name: 'Category' },
    { name: 'Min Suggested Hours', numerical: true },
    { name: 'Max Suggested Hours', numerical: true },
    { name: 'Event Date', options: { filter: false } },
    { name: 'Comments', options: { sort: false } },
  ];
  const openEventPopup = (rowData) => {
    // console.log(rowData);
    setIsPopupOpen(true);

    // Wait for popup form to load, then fill with values
    const fillData = setInterval(() => {
      if (modifyEventNameRef.current) {
        setSelectedEventId(rowData[0]);
        modifyEventNameRef.current.value = rowData[1];
        modifyEventCategoryRef.current.value = rowData[2];
        modifyEventMinHoursRef.current.value = rowData[3];
        modifyEventMaxHoursRef.current.value = rowData[4];
        onModifyEventDateValChange(new Date(rowData[5]));
        modifyEventCommentsRef.current.value = rowData[6];
        clearInterval(fillData);
      }
    }, 100);
  };

  const closeEventPopup = () => {
    setSelectedEventId(null);
    setIsPopupOpen(false);
  };

  const modifyEvent = (event) => {
    event.preventDefault();

    if (userContext.name === '') {
      alert('Not Authorized');
      return;
    }

    if (!selectedEventId) {
      alert('Error');
      return;
    }

    fetch(`${baseURL}/api/activity`, {
      method: 'PUT',
      body: JSON.stringify({
        name: modifyEventNameRef.current.value,
        activity_id: selectedEventId,
        category: modifyEventCategoryRef.current.value,
        min_suggested_hours: modifyEventMinHoursRef.current.value,
        max_suggested_hours: modifyEventMaxHoursRef.current.value,
        comments: modifyEventCommentsRef.current.value,
        event_date: `${modifyEventDateVal.getFullYear()}-${
          modifyEventDateVal.getMonth() + 1
        }-${modifyEventDateVal.getDate()}`,
      }),
      headers: {
        Authorization: `${userContext.tokenID}`,
        'Content-Type': 'application/json',
      },
    })
      .then((res) => {
        console.log(res);
        if (res.status === 200) {
          alert('Event was modified succesfully');
          window.location.reload();
        } else {
          const responseData = res.json();
          responseData.then((response) => {
            alert(response.error);
          });
        }
      })

      .catch((err) => {
        alert('POST Request Failed, Please try again later');
        console.log(err);
      });
  };

  const deleteEvent = () => {
    if (!selectedEventId) {
      alert('Error');
      return;
    }

    fetch(`${baseURL}/api/activity`, {
      method: 'DELETE',
      body: JSON.stringify({
        activity_id: selectedEventId,
      }),
      headers: {
        Authorization: `${userContext.tokenID}`,
        'Content-Type': 'application/json',
      },
    })
      .then((res) => {
        console.log(res);
        if (res.status === 200) {
          alert('Event was deleted successfully');
          window.location.reload();
        } else {
          alert('DELETE Request Failed, Please try again later');
          console.log(res.status);
        }
      })
      .catch((err) => {
        alert('DELETE Request Failed, Please try again later');
        console.log(err);
      });
  };

  useEffect(() => {
    fetch(`${baseURL}/api/activity`)
      .then((res) => res.json())
      .then((res) => {
        setEventData(res ? res.activities : []);
        // console.log(res);
        // console.log("EventData: ");
        // console.log(eventData);
      })
      .catch((err) => {
        setEventDataError(true);
        console.log(err);
      });
  }, [baseURL, userContext]);
  return (
    <>
      <MDBModal isOpen={isPopupOpen} toggle={closeEventPopup}>
        <MDBModalHeader toggle={closeEventPopup}>
          <p className="h3 mt-2">Modify/Delete Event</p>
        </MDBModalHeader>
        <MDBModalBody>
          <form onSubmit={modifyEvent}>
            <label htmlFor="eventName" className="black-text">
              Event Name
            </label>
            <input
              type="text"
              id="eventName"
              className="form-control"
              ref={modifyEventNameRef}
              required
            />

            <br />
            <label htmlFor="category" className="balck-text">
              Category
            </label>
            <div>
              <select
                className="browser-default custom-select"
                id="category"
                ref={modifyEventCategoryRef}
              >
                <option value="1">Category 1</option>
                <option value="2">Category 2</option>
                <option value="3">Category 3</option>
                <option value="4">Category 4</option>
                <option value="5">Category 5</option>
                <option value="6">Category 6</option>
              </select>
            </div>

            <br />
            <label htmlFor="date" className="black-text">
              Event Date
            </label>
            <div>
              <DatePicker
                value={modifyEventDateVal}
                onChange={onModifyEventDateValChange}
              />
            </div>

            <br />
            <label htmlFor="minhours" className="black-text">
              Minimum Suggested Hours
            </label>
            <input
              type="number"
              id="minhours"
              className="form-control"
              ref={modifyEventMinHoursRef}
              required
            />

            <br />
            <label htmlFor="maxhours" className="black-text">
              Maximum Suggested Hours
            </label>
            <input
              type="number"
              id="maxhours"
              className="form-control"
              ref={modifyEventMaxHoursRef}
              required
            />

            <br />
            <label htmlFor="comments" className="black-text">
              Comments
            </label>
            <input
              type="text"
              id="comments"
              className="form-control"
              ref={modifyEventCommentsRef}
            />

            <br />

            <div className="text-center mt-4">
              <MDBBtn color="primary" type="submit">
                Update
              </MDBBtn>
            </div>
          </form>
        </MDBModalBody>
        <MDBModalFooter>
          <MDBBtn color="red" onClick={deleteEvent}>
            Delete Event
          </MDBBtn>
        </MDBModalFooter>
      </MDBModal>
      <MDBContainer fluid>
        <p className="h2 text-center mb-4">Past Events</p>
        <DataTable
          tablename="Events"
          data={eventData}
          columns={columns}
          error={eventDataError}
          options={{
            onRowClick: openEventPopup,
            rowsPerPage: 15,
            rowsPerPageOptions: [10, 15, 20, 25, 50, 100],
          }}
        />
      </MDBContainer>
    </>
  );
}

export default PastEvents;
